import { render, staticRenderFns } from "./SendMailDialog.vue?vue&type=template&id=186a4984&scoped=true"
import script from "./SendMailDialog.vue?vue&type=script&lang=js"
export * from "./SendMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a4984",
  null
  
)

export default component.exports